import {
  AbstractControl,
  AsyncValidator,
  FormArray,
  FormGroup,
  ValidationErrors,
  Validators
} from '@angular/forms';
import { Injectable } from '@angular/core';
import { BankService } from '../../../../services/bank.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MustMatchValidator } from '../../../../utils/must-match.validator';

export function RoutingNumberMatchValidator(formGroup: FormGroup) {
  const result = MustMatchValidator('routingNumber', 'routingNumberMatch')(formGroup);
  if (result == null) {
    return result;
  }
  return { RoutingNumberMatch: true };
}
export function AccountNumberMatchValidator(formGroup: FormGroup) {
  const result = MustMatchValidator('accountNumber', 'accountNumberMatch')(formGroup);
  if (result == null) {
    return result;
  }
  return { AccountNumberMatch: true };
}

export function AllocationValidator(array: FormArray): ValidationErrors {
  //Validates that any records of type 'Percent of Net'
  //Do not exceed 100%
  const values: any[] = array.value;
  const percentOfNet = values.filter(x => x.amountType == 1);
  let total = 0;
  percentOfNet.forEach(item => {
    total += item.amount;
  });
  if (total <= 100) {
    return null;
  }
  return { AllocationExceeded: true };
}

export function NetRemainingValidator(array: FormArray): ValidationErrors {
  //Validates that only one record is set to Net Remaining
  const values: any[] = array.value;
  const netRemaining = values.filter(x => x.amountType == 2);
  if (netRemaining.length > 1) {
    return { MultipleNetRemaining: true };
  }
  return null;
}

@Injectable({ providedIn: 'root' })
export class RoutingNumberValidator implements AsyncValidator {
  constructor(private bankService: BankService) {}
  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    const number = control.value;
    if (number.length !== 9) {
      return of(null);
    }
    return this.bankService.getBank(number).pipe(
      map(result => {
        if (result != null) {
          return null;
        }
        return { invalidBank: true };
      }),
      catchError(err => {
        return of({ invalidBank: true });
      })
    );
  }
}
